import {useLazyQuery} from '@apollo/client';
import {useEffect} from 'react';
import {RequirementPots, RequirementPotsVariables} from '../schema-types/RequirementPots';
import {useAccountContext} from '../contexts/AccountContext';
import {useRecommendContext} from '../features/recommendations/CreateRecommend/CreateRecommendHelpers';
import {sanitiseProductType} from '../utils/sanitiseProductType';
import {LIST_SOURCES_DESTINATIONS} from '../features/potQueries';
import {useAutoForm} from '../components/AutoForm/useAutoForm';
import {recommendFieldsType} from '../features/recommendations/CreateRecommend/recommendFields';
import validateUUID from '../utils/validateUUID';

export function useSourcesAndDestinationPots() {
  const [
    getSourcesAndDestinations,
    {data: sourcesAndDestinations, loading: sourcesLoading, error: sourcesError},
  ] = useLazyQuery<RequirementPots, RequirementPotsVariables>(LIST_SOURCES_DESTINATIONS);
  const {values} = useAutoForm<recommendFieldsType>();
  const {accountId, account} = useAccountContext();
  const {recommendReviewId} = useRecommendContext();
  const contactId = (values.contact && validateUUID(values.contact)) || null;

  useEffect(() => {
    if (sourcesAndDestinations) {
      return;
    }
    getSourcesAndDestinations({
      variables: {
        accountId: account?.id || accountId,
        contactId,
        potType: sanitiseProductType(values.mainPlanType),
        planAction: values.planAction,
        reviewId: validateUUID(recommendReviewId),
        curoSync: false,
      },
    });
  }, []);

  return {
    sources: sourcesAndDestinations?.sources,
    destinations: sourcesAndDestinations?.destinations,
    sourcesAndDestinations: [
      ...(sourcesAndDestinations?.sources || []),
      ...(sourcesAndDestinations?.destinations || []),
    ],
  };
}
